import Head from "next/head";
import dynamic from "next/dynamic";
dynamic(() => import("tw-elements"), { ssr: false });

import styles from "../styles/Home.module.css";

export default function Home() {
  return (
    <div className={styles.container}>
      <Head>
        <title>
          Fast Job Posting, Search Jobs, Online Recruitment Portal -
          WorkIndia.in
        </title>
        <link
          href="https://webcdn.workindia.in/assets/favicon.ico"
          rel="icon"
          type="image/x-icon"
        />
        <link
          href="https://fonts.googleapis.com/css?family=Roboto"
          rel="stylesheet"
        />
      </Head>
    </div>
  );
}
